import React, { useEffect, useState } from "react";
import { TextField, Button, Alert } from "@mui/material";
import MotionWrapper from "../../../../../components/MotionWrapper";
import { useSelector } from "react-redux";

const ClassroomValiadation = ({ cartItem, setClassroomValidation, update }) => {
  // const cartItem = item;
  const [error, setError] = useState("");
  const { classroomRange } = useSelector((state) => state.cart);

  const validateAmounts = () => {
    const courseVal =
      cartItem?.admissionFee == 0
        ? Number(cartItem.discountedAmount)
        : Number(cartItem.discountedAmount - cartItem.admissionFee);
    const payingVal =
      cartItem?.admissionFee == 0
        ? Number(cartItem.paidAmt) +
          Number(cartItem.holdAmt ? cartItem.holdAmt : 0)
        : Number(cartItem.paidAmt - cartItem.admissionFee) +
          Number(cartItem.holdAmt ? cartItem.holdAmt : 0);

    if (
      isNaN(courseVal) ||
      isNaN(payingVal) ||
      courseVal <= 0 ||
      payingVal <= 0
    ) {
      setError("Paying amount  must be greater than admission fee....!");
      return;
    }

    // Ensure paying amount is not greater than course amount
    if (payingVal > courseVal) {
      setError("Paying amount cannot be greater than course amount.");
      return;
    }

    // Find the matching object based on courseAmount
    let matchedObject =
      cartItem.selectedCurrency === 1
        ? classroomRange.dataInr.find(
            (item) =>
              item.upperLimit !== "default" &&
              courseVal <= Number(item.upperLimit)
          )
        : classroomRange.dataAed?.find(
            (item) =>
              item.upperLimit !== "default" &&
              courseVal <= Number(item.upperLimit)
          );

    // If no match is found, use the "default" threshold
    if (!matchedObject) {
      matchedObject =
        cartItem.selectedCurrency === 1
          ? classroomRange.dataInr.find((item) => item.upperLimit === "default")
          : classroomRange.dataAed?.find(
              (item) => item.upperLimit === "default"
            );
    }

    if (!matchedObject) {
      setError("Invalid data configuration.");
      return;
    }

    const requiredPayingAmount = (matchedObject.threshold / 100) * courseVal;

    if (payingVal < requiredPayingAmount) {
      setError(
        `Minimum paying amount should be ${requiredPayingAmount.toFixed(2)} (${
          matchedObject.threshold
        }% of ${courseVal}) ${
          cartItem?.admissionFee == 0
            ? ""
            : `+ Admission fee (${cartItem?.admissionFee}) = ${
                requiredPayingAmount + cartItem?.admissionFee
              }`
        } `
      );
      setClassroomValidation((prev) => {
        if (update) {
          return { ...prev, isAvailable: true };
        } else {
          return { ...prev, newCourse: true };
        }
      });
    } else {
      setError("");
      setClassroomValidation((prev) => {
        if (update) {
          return { ...prev, isAvailable: false };
        } else {
          return { ...prev, newCourse: false };
        }
      });
    }
  };

  useEffect(() => {
    if (cartItem?.courseTypeId === 2 && cartItem.emi == false) {
      if (cartItem?.discountedAmount && cartItem?.paidAmt) {
        validateAmounts();
      } else {
        setError("");
      }
    }

    if (cartItem.emi === true) {
      setError("");
      setClassroomValidation((prev) => {
        return { ...prev, isAvailable: false, newCourse: false };
      });
    }
  }, [cartItem]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        // width: "300px",
      }}
    >
      <MotionWrapper delay={0.5} directions={"left"}>
        {error == "" ? null : <Alert severity="error">{error}</Alert>}
      </MotionWrapper>
    </div>
  );
};

export default ClassroomValiadation;
